/* Vendor_EVENTGET_VENDOR_EVENT */
export const GET_VENDOR_EVENT = "GET_VENDOR_EVENT"
export const GET_VENDOR_EVENT_SUCCESS = "GET_VENDOR_EVENT_SUCCESS"
export const GET_VENDOR_EVENT_FAIL = "GET_VENDOR_EVENT_FAIL"

/* Vendor_EVENTGET_VENDOR_EVENT PROFILE */
export const GET_VENDOR_EVENT_PROFILE = "GET_VENDOR_EVENT_PROFILE"
export const GET_VENDOR_EVENT_PROFILE_SUCCESS = "GET_VENDOR_EVENT_PROFILE_SUCCESS"
export const GET_VENDOR_EVENT_PROFILE_FAIL = "GET_VENDOR_EVENT_PROFILE_FAIL"

/**
 * add VENDOR_EVENT
 */
 export const ADD_NEW_VENDOR_EVENT = "ADD_NEW_VENDOR_EVENT"
 export const ADD_VENDOR_EVENT_SUCCESS = "ADD_VENDOR_EVENT_SUCCESS"
 export const ADD_VENDOR_EVENT_FAIL = "ADD_VENDOR_EVENT_FAIL"

 /**
 * Edit VENDOR_EVENT
 */
export const UPDATE_VENDOR_EVENT = "UPDATE_VENDOR_EVENT"
export const UPDATE_VENDOR_EVENT_SUCCESS = "UPDATE_VENDOR_EVENT_SUCCESS"
export const UPDATE_VENDOR_EVENT_FAIL = "UPDATE_VENDOR_EVENT_FAIL"

/**
 * Delete VENDOR_EVENT
 */
export const DELETE_VENDOR_EVENT = "DELETE_VENDOR_EVENT"
export const DELETE_VENDOR_EVENT_SUCCESS = "DELETE_VENDOR_EVENT_SUCCESS"
export const DELETE_VENDOR_EVENT_FAIL = "DELETE_VENDOR_EVENT_FAIL"


